module.exports = __webpack_public_path__ + "static/media/detalhes_active.ab67d163.svg";